import { FaUserFriends } from 'react-icons/fa';
import SectionCard from './SectionCard';
import PersonFields from './PersonFields';

const AdditionalPersons = ({
  additionalPersons,
  isAttending,
  updateAdditionalPerson,
  showError
}) => {
  if (additionalPersons.length === 0) return null;

  return (
    <SectionCard
      icon={FaUserFriends}
      title="Additional Attendees"
      subtitle="Enter the details for each additional person."
    >
      <div className="flex flex-col gap-6">
        {additionalPersons.map((p, i) => (
          <div key={i} className="rounded-xl border border-slate-200 bg-slate-50/60 p-5">
            <h3 className="text-base font-semibold text-[#13235f] mb-4">
              Person {isAttending === 'yes' ? i + 2 : i + 1}
            </h3>

            <PersonFields
              person={p}
              index={i}
              showError={showError}
              updatePerson={updateAdditionalPerson}
            />
          </div>
        ))}
      </div>
    </SectionCard>
  );
};

export default AdditionalPersons;
